import React, { useState, useEffect } from 'react';
import KeyValuePair from '../KeyValuePair';
import moment from 'moment';
import { Locale } from 'helpers/Enums';
import { LocalizationIds } from 'helpers/Localizations';

interface ILocaleContext {
    currentLocale: string
    locales: KeyValuePair<string, string>[]
    updateCurrentLocale: (newLocale: string) => void
}

export const localeContext = React.createContext({} as ILocaleContext);

const { Provider } = localeContext;

let LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [currentLocale, setCurrentLocale] = useState<string>(Locale.Italian);

    const [locales] = useState<KeyValuePair<string, string>[]>([
        new KeyValuePair<string, string>(Locale.Italian, LocalizationIds.Italian),
        new KeyValuePair<string, string>(Locale.English, LocalizationIds.English)
    ]);


    useEffect(() => {
        let localStorageLocale = localStorage.getItem("currentLocale");

        if (localStorageLocale === null)
            updateCurrentLocale(currentLocale);
        else
            updateCurrentLocale(localStorageLocale);
    }, [])


    const updateCurrentLocale = (newLocale: string) => {
        setCurrentLocale(newLocale);
        localStorage.setItem("currentLocale", newLocale);
        moment.locale(newLocale.substring(0, newLocale.indexOf("-")).toLowerCase());
    }


    return (
        <Provider
            value={{
                currentLocale,
                locales,
                updateCurrentLocale
            }}
        >
            {children}
        </Provider>
    )
}

export default LocaleProvider;